'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.bidderExistsSuccess = exports.getBidderExistsEmail = exports.getBidderExists = exports.BIDDER_EXISTS_SUCCESS = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _createAccount = require('./createAccount');

var _reselect = require('reselect');

var _modal = require('./modal');

var _login = require('./login');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var BIDDER_EXISTS_SUCCESS = exports.BIDDER_EXISTS_SUCCESS = 'la/ui/bidderExists/SUCCESS';

// reducer
var DEFAULT_STATE = {
    email: ''
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case BIDDER_EXISTS_SUCCESS:
            return (0, _extends3.default)({}, state, {
                email: action.payload.email
            });
        case _modal.DISMISS_LOGIN_MODAL:
        case _createAccount.CREATE_ACCOUNT_REQUEST:
        case _createAccount.CREATE_ACCOUNT_SUCCESS:
        case _login.LOGIN_SUCCESS:
            return (0, _extends3.default)({}, state, {
                email: ''
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.ui.bidderExists;
};

var getUiBidderExists = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state;
});

var getBidderExists = exports.getBidderExists = (0, _reselect.createSelector)(getUiBidderExists, function (state) {
    return !!state.email;
});

var getBidderExistsEmail = exports.getBidderExistsEmail = (0, _reselect.createSelector)(getUiBidderExists, function (state) {
    return state.email;
});

/* ACTION CREATORS */
var bidderExistsSuccess = exports.bidderExistsSuccess = function bidderExistsSuccess(email) {
    return {
        payload: { email: email },
        type: BIDDER_EXISTS_SUCCESS
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/bidderExists.js
// module id = uien
// module chunks = 46